import { render, staticRenderFns } from "./Familias.vue?vue&type=template&id=e5db91c4&scoped=true&"
import script from "./Familias.vue?vue&type=script&lang=js&"
export * from "./Familias.vue?vue&type=script&lang=js&"
import style0 from "./Familias.vue?vue&type=style&index=0&id=e5db91c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5db91c4",
  null
  
)

export default component.exports